<template>
  <div>
    <div v-if="loading" class="bz-empty">Checking offered sales classes…</div>
    <template v-else>
      <div v-if="offered" class="bz-sc-note" :class="{ warn: scarce }">
        <i class="material-icons" style="font-size:15px;line-height:1;">{{ scarce ? 'warning_amber' : 'check_circle' }}</i>
        <span>{{ offeredSelectable }} of 15 sales classes offered for <code>{{ industry.code }}</code></span>
      </div>
      <div class="bz-sc-list">
        <button v-for="sc in catalog" :key="sc.id" type="button"
          class="bz-sc-row" :class="{ sub: !!sc.group, sel: value === sc.id, off: offered && !isOffered(sc.id) }"
          :disabled="offered && !isOffered(sc.id)"
          @click="$emit('change', sc.id)">
          <span class="bz-dot" :class="!offered || isOffered(sc.id) ? 'ok' : 'no'"></span>
          <span>{{ sc.label }}</span>
          <span v-if="offered && !isOffered(sc.id)" class="bz-sc-meta">not offered</span>
        </button>
      </div>
    </template>
  </div>
</template>

<script>
// Offered bands come straight from /info/sales_classes?type=if&industry=<code>
// — sales-class availability depends only on the industry (matches the API),
// so this list is final as soon as the industry is picked.
import { SALES, fetchOfferedSalesClasses } from './model';

export default {
  name: 'sales-class-step',
  props: {
    industry: { type: Object, required: true },
    value: { type: String, default: null },
  },
  data() {
    return { catalog: SALES, offered: null, loading: false };
  },
  computed: {
    // A group header (small/medium/large) is offered when the endpoint lists
    // that id OR any of its sub-bands — matching the classic selector. The
    // /info/sales_classes response is inconsistent (returns 'large' but not
    // 'small'/'medium' for some industries), and the backend accepts the group
    // id as a sale class regardless, so deriving from children is correct.
    effectiveOffered() {
      if (!this.offered) return null;
      const set = {};
      this.offered.forEach((id) => { set[id] = true; });
      ['small', 'medium', 'large'].forEach((g) => {
        if (this.catalog.some((sc) => sc.group === g && set[sc.id])) set[g] = true;
      });
      return set;
    },
    offeredSelectable() {
      if (!this.effectiveOffered) return 15;
      return this.catalog.filter((sc) => this.effectiveOffered[sc.id]).length;
    },
    scarce() {
      return this.offeredSelectable <= 4;
    },
  },
  watch: {
    industry: {
      immediate: true,
      handler() {
        this.load();
      },
    },
  },
  methods: {
    isOffered(id) {
      return !!(this.effectiveOffered && this.effectiveOffered[id]);
    },
    async load() {
      if (!this.industry) return;
      this.loading = true;
      try {
        this.offered = await fetchOfferedSalesClasses(this.industry.code);
      } catch (e) {
        this.offered = null; // degrade: show all bands enabled
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
